import { render, staticRenderFns } from "./discount-add.vue?vue&type=template&id=eb047844&"
import script from "./discount-add.vue?vue&type=script&lang=js&"
export * from "./discount-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports